import  { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../../../context/LodingContext";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import { Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialButton from "../../../../components/MaterialButton";
import {
  CompetitorAnalysisState,
  CompetitorAnalysisStateMange,
  createCompetitorProduct,
  getCompetitorProductById,
  updateCompetitorProduct,
} from "../data";
import MaterialInput from "../../../../components/MaterialInput";
import ImageSelector from "../../../components/ImageSelector";
import Swal from "sweetalert2";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { useMutation } from "@apollo/client";
import meadiaURL from "../../../../pages/Utils/url";
import FullscreenIcon from '@mui/icons-material/Fullscreen';


const CompetitorAnalysisForm = () => {
  const [competitorAnalysis, dispatch] = useReducer(
    CompetitorAnalysisStateMange,
    CompetitorAnalysisState
  );
  const [inputDisble, setInputDisble] = useState(false);
  const [dialogOpen,setDialogOpen] = useState(false);
  const [productImgUrl, setProductImgUrl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();
  const formType = location?.state?.type;
  const rowId = location?.state?.data;

  const [createCompetitorAnalysis] = useMutation(
    createCompetitorProduct
  );
  const [updateCompetitorAnalysis] = useMutation(updateCompetitorProduct);

  // change formType Add or edit or View usi ng input disble or enable
  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  useEffect(() => {
    if (rowId) {
      fetchRowData(rowId);
    }
  }, [rowId]);

  const handleSubmit = async () => {
    setCirleLoading(true);

    const value = {
      productCode: competitorAnalysis?.productCode,
      productName: competitorAnalysis?.productName,
      productImage: competitorAnalysis?.productImage,
      productBrand: competitorAnalysis?.productBrand,
      productCategory: competitorAnalysis?.productCategory,
      competitorPrice: Number(competitorAnalysis?.competitorPrice),
    };

    if (formType == "add") {
      await onSumbit(value);
    } else if (formType == "edit") {
      await onUpdate(value);
    }
    setCirleLoading(false);
  };

  // add function
  const onSumbit = async (value) => {
    try {
      const res = await createCompetitorAnalysis({
        variables: {
          input: {
            userId: userId,
            ...value,
          },
        },
        context: { hasUpload: true },
      });

      const status = res?.data?.createCompetitorProduct?.success;
      const message = res?.data?.createCompetitorProduct?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/competitor-Analysis");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {}
  };
  // edit function
  const onUpdate = async (value) => {
    try {
      const res = await updateCompetitorAnalysis({
        variables: {
          input: {
            productId: rowId,
            ...value,

            productImage: competitorAnalysis?.productImage?.name
              ? competitorAnalysis?.productImage
              : null,
          },
        },
        context: { hasUpload: true },
      });

      const status = res?.data?.updateCompetitorProduct?.success;
      const message = res?.data?.updateCompetitorProduct?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/competitor-Analysis");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {}
  };
  const handleImageSelect = (file) => {
    dispatch({ value: file, name: "productImage" });
  };

  // fetchRowdata
  const fetchRowData = async (id) => {
    setCirleLoading(true);
    try {
      const response = await request(BASEURL, getCompetitorProductById, {
        id: id,
      });

      const value = response?.getCompetitorProductById?.data[0];

      dispatch({ value: value?.productCode, name: "productCode" });
      dispatch({
        value: value?.productName,
        name: "productName",
      });
      dispatch({
        value: value?.productBrand,
        name: "productBrand",
      });
      dispatch({
        value: value?.productCategory,
        name: "productCategory",
      });
      dispatch({
        value: value?.competitorPrice,
        name: "competitorPrice",
      });
      setProductImgUrl(
        value?.productImage ? `${meadiaURL}media/${value?.productImage}` : null
      );
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleDownload = async()=>{
    const imageUrl = productImgUrl;
    if(!imageUrl) return;

    const response  = await fetch(imageUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "product_image.jpg";
    a.click();
     URL.revokeObjectURL(url);
  }
  return (
    <DashboardLayout>
      <Dialog open={dialogOpen} onClose={()=>setDialogOpen(false)} maxWidth="md">
        <DialogContent
         sx={{ display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden", // prevent scrollbars
    p: 0,}}
        >
        {ImageSelector ? (
          <img
          src={productImgUrl}
          alt="ProductImage"
           style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "8px",objectFit: "contain",display: "block" }}
          />
        ):(
           <MaterialTypography>No image available</MaterialTypography>
        )}
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setDialogOpen(false)}>Close</Button>
          {formType == "view"
           ?<Button onClick={handleDownload}>Download</Button>:""
          }
        
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add"
                    : formType == "edit"
                    ? "Edit"
                    : "View"}{" "}
                  Competitor Analysis Details
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={competitorAnalysis?.productCode}
                  name="productCode"
                  placeholder="Enter Product Code"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productCode" })
                  }
                  error={
                    competitorAnalysis.productCodeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    competitorAnalysis.productCodeStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={competitorAnalysis?.productName}
                  name="productName"
                  placeholder="Enter Product Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productName" })
                  }
                  error={
                    competitorAnalysis.productNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    competitorAnalysis.productNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Brand <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={competitorAnalysis?.productBrand}
                  name="productBrand"
                  placeholder="Enter Product Brand"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productBrand" })
                  }
                  error={
                    competitorAnalysis.productBrandStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    competitorAnalysis.productBrandStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={competitorAnalysis?.productCategory}
                  name="productCategory"
                  placeholder="Enter Product Category"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "productCategory",
                    })
                  }
                  error={
                    competitorAnalysis.productCategoryStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    competitorAnalysis.productCategoryStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Competitor Price <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="number"
                  value={competitorAnalysis?.competitorPrice}
                  name="competitorPrice"
                  placeholder="Enter Competitor Price"
                  disabled={inputDisble}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (Number(value) >= 0 || value === "") {
                      dispatch({
                        value: value,
                        name: "competitorPrice",
                      });
                    }
                  }}
                  error={competitorAnalysis.competitorPriceStatus === "error"}
                  success={
                    competitorAnalysis.competitorPriceStatus === "success"
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Image
                  </MaterialTypography>
                </MaterialBox>
                
                <FullscreenIcon
                fontSize="small"
                className="viewIcon"
                onClick ={()=>{
                setDialogOpen(true);
                }}
                 style={{ cursor: "pointer", marginLeft: "8px", verticalAlign: "middle" }}
                />

                <ImageSelector
                  onImageSelect={handleImageSelect}
                  imageUrl={productImgUrl}
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/competitor-Analysis")}
            >
              Cancel
            </MaterialButton>
             {formType != "view" && (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={handleSubmit}
            >
              {formType == "add" ? "Submit" : "update"}       
            </MaterialButton>
             )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default CompetitorAnalysisForm;
